import config from '../../../constants/config';
import moment from '../../../utils/moment';
import NormalButton from '../../Buttons/NormalButton';
import React from 'react';
import store from '../../../store';
import SVG from 'src/components/Images/SvgRenderer';
import theme from 'src/ui/theme';
import useStyles from './style';
import { FallbackProps } from 'react-error-boundary';
import { getAppApiServer, getAppData } from '../../../utils/useApp';
import { getQueryParams, getQueryString, isValidHexColor } from 'src/utils/useFunctions';
import { saveAs } from 'file-saver';
import { serializeError } from 'serialize-error';
import { setLogoutUserController } from 'src/store/actions/controllers.actions';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux-hooks';
import { useEffect } from 'src/utils/useEffect';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const ErrorScreen: React.FunctionComponent<FallbackProps> = ({error, resetErrorBoundary}) => {
  
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useAppSelector((state: any) => state.user);
  const { t } = useTranslation();

  const queryParams = getQueryParams(location);
  const queryString = getQueryString(location);
  const embed = queryParams.get("embed");
  const isEmbed = embed === "true" ? true : false;
  const background = queryParams.get("background");
  const backgroundColor = isEmbed ? (background === "gradient" ? theme.colors.gradient : (isValidHexColor(`#${background}`) ? `#${background}` : theme.colors.white)) : theme.colors.white;

  const savedData = getAppData();
  const savedUsers = savedData.users ? savedData.users : [];

  const classes = useStyles({
    backgroundColor: backgroundColor,
  });

  const handleSwitch = () => {
    navigate(`/auth/switch${queryString}`);
  };

  const handleLogout = () => {
    dispatch(setLogoutUserController(true));
  };

  const handleDownloadLog = () => {
    let text = [];
    text.push("Twigsee WebApp Error log");
    text.push(`Environment: ${config.APP_ENVIRONMENT}`);
    text.push(`API server: ${getAppApiServer()}`);
    text.push(`Date: ${moment().format("YYYY-MM-DD HH:mm:ss")}`);
    text.push(`Version: ${config.APP_VERSION}`);
    text.push(`Location: ${location.pathname}`);
    text.push("");
    text.push("Errors:");
    text.push(JSON.stringify(serializeError(error))); 
    text.push("");
    text.push("Error messages:");
    text.push(error.message);       
    if(userData.userObject) {
      text.push("");
      text.push("User:");
      text.push(JSON.stringify(userData.userObject));
    }
    text.push("");
    text.push("Redux Store:");
    text.push(JSON.stringify(store.getState()));
    let blob = new Blob([text.join("\n")], {type: "text/plain;charset=utf-8"});
    let file_name = `twigsee_webapp_error_log_${moment().format("YYYY_MM_DD_HH_mm_ss")}.txt`;
    saveAs(blob, file_name);  
  };

  const handleClickTryAgain = () => {
    window.location.reload();
  };

  useEffect(() => {
    if(userData.userStatus === "loggedOff") {
      window.location.reload();
    }
  }, [userData.userStatus], [userData.userStatus]);
  
  return (
    <div className={classes.errorScreen}>
      <SVG src={config.APP_LOGO}/>
      <div className={classes.failed}>
        <span>{config.APP_ENVIRONMENT === "production" ? t('error') : t('error_occured')}.</span>
        <div className={classes.buttons}>
        {
          config.APP_ENVIRONMENT !== "production" ? (
            <NormalButton buttonType="primary" onClick={handleDownloadLog} dataCy="errorScreenDownloadButton">
              {t("download_log")}
            </NormalButton>
          ) : null
        }
        <NormalButton buttonType="secondary" onClick={handleClickTryAgain}>
          {t("try_again")}
        </NormalButton>
        {
          (Object.keys(userData.userObject).length > 0 && !isEmbed) ? (
            <>
              {
                savedUsers.length > 1 ? (
                  <NormalButton buttonType="tertiary" onClick={handleSwitch}>
                    {t("switch_user")}
                  </NormalButton>
                ) : (
                  <NormalButton buttonType="tertiary" onClick={handleLogout}>
                    {t("logout")}
                  </NormalButton>
                )
              }
            </>
          ) : null
        }
        </div>
      </div>        
    </div>
  );
};

export default ErrorScreen;